export const LOCAL_STORAGE_KEYS = {
  EE_LOGIN_USER_NAME: 'EE_USER_ID',

  IDF_ACCESS_TOKEN: 'IDF_ACCESS'
}